module.exports = __webpack_public_path__ + "static/preisrechner-bg-a5e6b3c4fc11df29906cef00e9098e65.png";